import { GlobalDtoSchema } from "../content-types/schemas/global.schema";
import { extractData } from "../utils/extract-dto-data";
import { safeParseWithFallback } from "../utils/safe-parse-with-fallback";

export const mapDtoToGlobal = (dto: unknown) => {
  const parsed = safeParseWithFallback(GlobalDtoSchema, dto, "mapDtoToGlobal");

  return extractData(parsed, dto, dto);
};
